import React from "react";

import flattenChildren from "react-keyed-flatten-children";

import useResponsiveProp from "../../../hooks/useResponsiveProp";
import { ResponsiveDimension, ResponsiveProp } from "../../../types";
import Box from "../Box";

type Props = {
  columns: ResponsiveProp<number>;
  children: React.ReactNode;
  space: ResponsiveDimension;
};

export default function Tiles({ columns, children, space }: Props) {
  const numColumns = useResponsiveProp(columns);

  return (
    <Box
      display="grid"
      gridTemplateColumns={`repeat(${numColumns}, 1fr)`}
      width="100%"
      gap={space}
    >
      {React.Children.toArray(flattenChildren(children))}
    </Box>
  );
}
